module.exports = __webpack_public_path__ + "static/2-7830c48452f47b4fc288356304d1bee3.jpg";